import callAPiBase from './base';

const tagsApi = {
  list: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/api/tags',
      method: 'GET',
      useToken: true,
      params,
    }),
  get: ({ ID }: { ID: string }) =>
    callAPiBase({
      endpoint: `/api/tag?ID=${ID}`,
      method: 'GET',
      useToken: true,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/api/tags',
      method: 'POST',
      useToken: true,
      data,
    }),
  update: ({ ID, data }: { ID: string; data: object }) =>
    callAPiBase({
      endpoint: `/api/tag?ID=${ID}`,
      method: 'PUT',
      useToken: true,
      data,
    }),
  delete: ({ ID }: { ID: string }) =>
    callAPiBase({
      endpoint: `/api/tags?ID=${ID}`,
      method: 'DELETE',
      useToken: true,
    }),
};

export { tagsApi };
export default tagsApi;
